import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { SourcefoundingService } from '../../../../core/services/sourcefounding/sourcefounding-service';
import { Sourcefounding } from '../../../../core/models/sourcefounding.interface';
import { FormUtils } from '../../../../shared/utils';

@Component({
  selector: 'app-sourcefounding-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './sourcefounding-form.html',
  styleUrl: './sourcefounding-form.scss',
})
export class SourcefoundingForm {
  sourcefounding: string | null = null;
  errorMsg: string[] | null = null;
  sourcefoundingselected: Sourcefounding | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<SourcefoundingForm>,
    private toastr: ToastrService,
    private serviceSourcefounding: SourcefoundingService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceSourcefounding.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceSourcefounding.selectedsourcefounding$.subscribe((sourcefounding) => {
      if (sourcefounding) {
        this.sourcefounding = String(sourcefounding.id);
        this.sourcefoundingselected = sourcefounding;
        this.sourcefoundingForm.patchValue({
          ...sourcefounding,
        });
      }
    });
  }

  sourcefoundingForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(150)]],
    description: ['', [Validators.required]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveSourcefounding() {
    const payload = this.sourcefoundingForm.value as Sourcefounding;
    if (this.sourcefoundingForm.status === 'VALID' && !this.sourcefounding) {
      this.loadingService.show(true);
      this.serviceSourcefounding.createSourcefounding(payload).subscribe({
        next: (sourcefounding) => {
          this.loadingService.show(false);
          const msg = `La fuente ${sourcefounding.name} fue CREADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.sourcefoundingForm.status === 'VALID' && this.sourcefounding) {
      this.loadingService.show(true);
      const id = Number(this.sourcefounding);
      this.serviceSourcefounding.UpdateSourcefounding(id, { ...payload, id: id }).subscribe({
        next: (sourcefounding) => {
          this.loadingService.show(false);
          const msg = `La fuente ${sourcefounding.name} fue EDITADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
